import { AnimatePresence } from 'motion/react'
import { useContextPanels } from '../../contexts/panelsContext'
import { UIElement } from '../../types/UIElements'
import GeographicFilterOverlay from './GeographicFilterOverlay'

const GeographicFilter = () => {
  const { isPanelOpen, closeAll } = useContextPanels()

  const handleCloseGeoFilter = () => {
    window.history.replaceState(null, '', '/')
    closeAll()
  }

  return (
    <AnimatePresence>
      {isPanelOpen(UIElement.GEOFILTER) ? (
        <GeographicFilterOverlay key="geo-filter" onClose={handleCloseGeoFilter} />
      ) : null}
    </AnimatePresence>
  )
}

export default GeographicFilter
